import {Component, Input, OnInit} from '@angular/core';
import {NavMenuItem} from '../../../core/models/nav-menu-item.interface';
import {DownloadDataDialogComponent} from '../../../core/components/download-data-dialog/download-data-dialog.component';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-dashboard-item',
  templateUrl: './dashboard-item.component.html',
  styleUrls: ['./dashboard-item.component.scss']
})
export class DashboardItemComponent implements OnInit {

  @Input()
  item!: NavMenuItem;

  constructor(private readonly dialog: MatDialog) { }

  ngOnInit(): void {
  }

  openDownloadDialog(type?: string): void {
    const dialogRef = this.dialog.open(DownloadDataDialogComponent, {data: type,  maxWidth: 600, width: 'inherit'});
  }

}
